import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';
import { BLOG_POSTS } from '../data/content';
import SEO from '../components/SEO';

export default function Blog() {
  return (
    <>
      <SEO title="Removals Blog — Moving Tips & Guides | Laraé Logistics"
        description="Practical guides on house removals, packing, moving costs and office relocations in London. Written by movers, for movers." />
      <section className="bg-forest text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
          <p className="font-manrope text-sm text-oat uppercase tracking-widest mb-3">Blog</p>
          <h1 className="font-outfit text-4xl md:text-5xl lg:text-6xl font-medium tracking-tight max-w-3xl">Moving guides &amp; expert tips.</h1>
        </div>
      </section>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BLOG_POSTS.map(p => (
            <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white border border-sand rounded-2xl p-7 hover:border-forest hover:shadow-md transition-all">
              <div className="flex items-center gap-3 text-xs text-ink/50 font-manrope mb-3"><Clock size={12} />{p.readMinutes} min read · {p.date}</div>
              <h2 className="font-outfit text-xl font-semibold text-ink leading-snug">{p.title}</h2>
              <p className="font-manrope text-sm text-ink/65 mt-3 leading-relaxed">{p.excerpt}</p>
              <div className="flex items-center gap-1.5 text-forest font-manrope text-sm font-medium mt-5 group-hover:gap-2.5 transition-all">Read article <ArrowRight size={14} /></div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
